export interface TranslateOptions {
  ptBr: string
  en: string
}

export function translateText(text: TranslateOptions) {
  if (!text) return null
  const language = localStorage.getItem('language') as string
  const translatedText = language === 'pt-BR' ? text.ptBr : text.en
  return translatedText
}
